import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFeedbackStore = defineStore('feedback', () => {
  // --- State ---
  const feedbackData = ref(null);
  const feedbackSentiment = ref(null);
  const activeFeedbackPopoverId = ref(null);

  // --- Actions ---
  function setFeedbackData(value) {
    feedbackData.value = value;
  }
  function setFeedbackSentiment(sentiment) {
    feedbackSentiment.value = sentiment;
  }
  function setActiveFeedbackPopoverId(popoverId) {
    activeFeedbackPopoverId.value = popoverId;
  }
  function clearActiveFeedbackPopover() {
    activeFeedbackPopoverId.value = null;
  }

  return {
    feedbackData,
    feedbackSentiment,
    activeFeedbackPopoverId,
    setFeedbackData,
    setFeedbackSentiment,
    setActiveFeedbackPopoverId,
    clearActiveFeedbackPopover,
  };
});
